const $progressLine = $('.js-progressLine')

$(window).on('scroll load', () => {
  if ($progressLine.length > 0) {
    const scrolled = $(window).scrollTop()
    const documentHeight = $(document).height() - $(window).height()
    const percent = (scrolled * 100) / documentHeight

    $progressLine.css('width', `${percent}%`)
  }
})
